import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loadingState: false,
        token: null,
        user: null,
        tagTypes : null,
        breadCrump : {
            "title":"Dashboard",
            "items":[

                {
                    path: '/',
                 
                    name: 'route-index',
                    component: () => import('./views/contract/list.vue'),
                    meta: {
                        auth: true,
                        label: "Home"
                    },
                }
            ]
        }
    },
  mutations: {
    changeLoadingState(state, { value }) {
      state.loadingState = value;
    },
   
      authUser(state, { user }) {
          state.token =user.token;
          state.user = user;
            localStorage.setItem('leasing-api', JSON.stringify(user));
        axios.defaults.headers['Authorization'] = `Bearer ${state.token}`;
    },
      clearAuth(state) {
          state.token = null;
          state.user = null;
          localStorage.removeItem('leasing-api');
          axios.defaults.headers['Authorization'] = null;
      }
     
  },
    actions: {

        login({ commit }, { username, password }) {
            var theToken = null;
            return axios
                .post('user/authenticate', {
                    username: username,
                    password: password
                })
        },
        autoLogin({ commit, dispatch }) {
            if(localStorage.getItem('leasing-api')){
            var user = JSON.parse(localStorage.getItem('leasing-api'));
            if (user != null) {
                commit('authUser', { user: user });
            } else {
                dispatch('logout');
            }
        }
    else{
        dispatch('logout');
    }
        },
        verifyToken({ commit }, { token }) {
            axios.defaults.headers['Authorization'] = `Bearer ${token}`;
            return axios
                .get('user/userinfo');

        },
        logout({ commit }) {
            commit('clearAuth');
        }
        ,
        userInfo({ commit }) {
           
            axios
                .get('user/UserInfo').then(response => {
                    
                });

        }
       
  

    },
    getters: {
        isLoading: state => {
            return state.loadingState;
        },
        isAuthenticated: state => {
            return state && state.token != null;
        }
    }
});
